import { render, staticRenderFns } from "./CriterionDetailsDialog.vue?vue&type=template&id=42117ac2"
import script from "./CriterionDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./CriterionDetailsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports